// extracted by mini-css-extract-plugin
module.exports = {"ministryList":"index_ministryList__31buJ","link":"index_link__3o6xX"};